<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--비상대피 훈련 개요-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot" /> 비상대피 훈련 개요</h5>
      </vs-col>
    </vs-row>
    <div class="writeGridContainer mt-4">
      <div>
        <div>시기</div>
        <p v-if="isPrint" class="print-input">{{ form.inputA_1 }}</p>
        <ml-input v-else v-model="form.inputA_1" :readonly="board.readonly" />
      </div>
      <div>
        <div>장소</div>
        <p v-if="isPrint" class="print-input">{{ form.inputA_2 }}</p>
        <ml-input v-else v-model="form.inputA_2" :readonly="board.readonly" />
      </div>
      <div>
        <div>참여범위</div>
        <p v-if="isPrint" class="print-input">{{ form.inputA_3 }}</p>
        <ml-input v-else v-model="form.inputA_3" :readonly="board.readonly" />
      </div>
      <div class="writeGridLineItem">
        <div>훈련방법</div>
        <span v-if="isPrint" class="print-textarea"> {{ form.inputA_4 }} </span>
        <ml-textarea v-else v-model="form.inputA_4" :readonly="board.readonly" rows="5"/>
      </div>
      <div class="writeGridLineItem">
        <div>주요내용</div>
        <span v-if="isPrint" class="print-textarea"> {{ form.inputA_5 }} </span>
        <ml-textarea v-else v-model="form.inputA_5" :readonly="board.readonly" rows="5"/>
      </div>
      <div class="writeGridLineItem">
        <div>평가</div>
        <span v-if="isPrint" class="print-textarea"> {{ form.inputA_6 }} </span>
        <ml-input v-else v-model="form.inputA_6" :readonly="board.readonly" />
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>

  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";

export default {
  components: {
    PhotoUploadGridModule,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      showPopup: false,
      form: {
        stdInfo: {},
        fileList: [],
        photoList: [],

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",
        inputA_4: "",
        inputA_5: "",
        inputA_6: "",
      },
    };
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">

</style>
